
import { Vue, Component } from "vue-property-decorator";
import { UFFeedback } from "@/utils/literals/feedback";
import { assetsUrl } from "@/env";
import ScorePin from "@/components/feedback/components/ScorePin.vue";
import { mapGetters, mapState } from "vuex";
import { FeedbackType } from "@/schemas/Enums";
import Score from "@/components/feedback/components/Score.vue";

@Component({
  components: { Score, ScorePin },
  computed: {
    ...mapState("session", ["session"]),
  },
})
export default class Intro extends Vue {
  getUFFb(key: string): string {
    return UFFeedback[key] || "";
  }
  getImgUrl(fileName: string): string {
    return `${assetsUrl}/svg/${fileName}`;
  }
  data(): any {
    return {
      steps: [],
      scoreMax: 112,
    };
  }

  created(): void {
    this.steps = [
      {
        interval: {
          min: 0,
          max: this.scoreMax / 7,
        },
        // color: "red",
        color: "green lighten-5",
      },
      {
        interval: {
          min: this.scoreMax / 7,
          max: (2 * this.scoreMax) / 7,
        },
        color: "green lighten-4",
        // color: "deep-orange",
      },
      {
        interval: {
          min: (2 * this.scoreMax) / 7,
          max: (3 * this.scoreMax) / 7,
        },
        color: "green lighten-3",
        // color: "orange",
      },
      {
        interval: {
          min: (3 * this.scoreMax) / 7,
          max: (4 * this.scoreMax) / 7,
        },
        // color: "amber",
        color: "green lighten-2",
      },
      {
        interval: {
          min: (4 * this.scoreMax) / 7,
          max: (5 * this.scoreMax) / 7,
        },
        // color: "yellow",
        color: "green lighten-1",
      },
      {
        interval: {
          min: (5 * this.scoreMax) / 7,
          max: (6 * this.scoreMax) / 7,
        },
        // color: "lime",
        color: "green darken-2",
      },
      {
        interval: {
          min: (6 * this.scoreMax) / 7,
          max: this.scoreMax,
        },
        color: "green darken-4",
        // color: "green",
      },
    ];
  }

  getPercentage(value: number): number {
    return (value * 100) / this.scoreMax;
  }

  getStepStyle(step: Record<string, any>): string {
    return `left: ${this.getPercentage(step.interval.min)}%;
          width: ${this.getPercentage(
            step.interval.max - step.interval.min
          )}%;`;
  }
}
